export default "__VITE_ASSET__PbNsikNW__"